import React from 'react'

function WatchAccessDenied (props) {
  return <>{props.children}</>
}

WatchAccessDenied.propTypes = {}

export default React.memo(WatchAccessDenied)
